import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';

import { CognitionBanner } from '@app/shared/ui/molecules/Cognition';
import { COGNITION_DAILY_BANNERS } from '@app/shared/constants/cognition';
import { usePageTimer } from '@app/shared/hooks/usePageTimer';
import { useLiveCountdown } from '@app/shared/hooks/useLiveCountdown';
import { CooldownView } from '@app/shared/ui/molecules/Common';
import notification from '@app/shared/utils/notification';

export function DailyBannersSection() {
  const navigate = useNavigate();

  const handleClick = (isAvailable: boolean, route: string, timeLeft?: string) => {
    if (isAvailable) {
      void navigate(route);
      return;
    }
    notification.error(t(`common.available_after`, { value: timeLeft }));
  };

  const timers = COGNITION_DAILY_BANNERS.map((banner) => {
    if (!banner.cooldownKey) {
      return null;
    }
    const { lastAt } = usePageTimer(banner.cooldownKey, banner.cooldown);
    const { isExpired, formattedLeft } = useLiveCountdown(lastAt ?? 0, banner.cooldown);
    return { isExpired, formattedLeft };
  });

  return (
    <ul className="space-y-[10px]">
      {COGNITION_DAILY_BANNERS.map((banner, index) => {
        const timer = timers[index];
        const element = (
          <CognitionBanner
            route={banner.route}
            tKeyTitle={banner.tKeyTitle}
            tKeyDescription={banner.tKeyDescription}
            imgSrc={banner.imgSrc}
          />
        );

        if (banner.cooldownKey && timer) {
          return (
            <CooldownView
              key={banner.route}
              isAvailable={timer.isExpired}
              formattedLeft={timer.formattedLeft}
              timerClassName="left-[89%] top-5"
              onClick={() => {
                handleClick(timer.isExpired, banner.route, timer.formattedLeft);
              }}
            >
              {element}
            </CooldownView>
          );
        }

        return (
          <li
            key={banner.route}
            onClick={() => {
              handleClick(true, banner.route);
            }}
          >
            {element}
          </li>
        );
      })}
    </ul>
  );
}
